import { RefAttributes, useCallback, useRef } from "react";
import { TextInput, TextInputProps } from "react-native";

export type ChainTextInputProps = Pick<
    TextInputProps,
    "blurOnSubmit" | "returnKeyType" | "onSubmitEditing"
> &
    RefAttributes<TextInput>;

export const useChainInputFocus = () => {
    const refs = useRef<TextInput[]>([]);
    const chainInputFocus = useCallback(
        (index: number) => {
            const nextInput = refs.current.filter((e) => e)[index + 1];
            return {
                ref: (r: TextInput) => (refs.current[index] = r),
                ...(nextInput
                    ? {
                          blurOnSubmit: false,
                          returnKeyType: "next" as const,
                          onSubmitEditing: () => {
                              nextInput.focus();
                          },
                      }
                    : {
                          blurOnSubmit: true,
                          returnKeyType: "done" as const,
                      }),
            } as ChainTextInputProps;
        },
        [refs],
    );

    return { chainInputFocus };
};
